// Stream type for tracking purposes
export var GT12StreamType;
(function (GT12StreamType) {
    GT12StreamType["REPLAY"] = "replay";
    GT12StreamType["RECORDING"] = "recording";
})(GT12StreamType || (GT12StreamType = {}));
